// MARK://dhk8/admin-shell/lib/use-async
// Tiny data-loading hook: runs a fetcher on mount, exposes { data, loading, error, reload }.
// Keeps the modules dependency-free of react-query for simple list screens (react-query
// is still available for anything fancier).
import { useCallback, useEffect, useState } from 'react'

export function useAsync<T>(fetcher: (signal: AbortSignal) => Promise<T>, deps: unknown[] = []) {
  const [data, setData] = useState<T | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [tick, setTick] = useState(0)
  const reload = useCallback(() => setTick((t) => t + 1), [])
  useEffect(() => {
    const ctrl = new AbortController()
    let alive = true
    setLoading(true); setError(null)
    fetcher(ctrl.signal)
      .then((d) => { if (alive) { setData(d); setLoading(false) } })
      .catch((e: unknown) => { if (alive && !ctrl.signal.aborted) { setError(e instanceof Error ? e.message : String(e)); setLoading(false) } })
    return () => { alive = false; ctrl.abort() }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tick, ...deps])
  return { data, loading, error, reload, setData }
}

/** Standard loading/error block to drop above a list. */
export function asyncState(loading: boolean, error: string | null, onRetry: () => void): React.ReactNode {
  if (loading) return <div className="adm-empty">Cargando…</div>
  if (error) return (
    <div className="adm-banner adm-banner--danger" role="alert">
      Error: {error} <button className="adm-btn adm-btn--sm" style={{ marginLeft: 8 }} onClick={onRetry}>Reintentar</button>
    </div>
  )
  return null
}
